function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Gender Male Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.3274552,0.528168085 C19.6656266,0.528168085 19.9455895,0.77738816 19.993697,1.10218139 L20.001,1.20171291 L20.001,7.93850827 C20.001,8.3104968 19.6994437,8.61205309 19.3274552,8.61205309 C18.9892838,8.61205309 18.7093208,8.36283302 18.6612133,8.03803979 L18.6539103,7.93850827 L18.6535,2.82716809 L13.7342723,7.74754944 C14.5938471,8.9017058 15.1199377,10.3188532 15.1698077,11.8562554 L15.1737042,12.0968393 C15.1737042,16.122135 11.9098978,19.3859414 7.88460211,19.3859414 C3.85930644,19.3859414 0.5955,16.122135 0.5955,12.0968393 C0.5955,8.07154364 3.85930644,4.8077372 7.88460211,4.8077372 C9.79429997,4.8077372 11.5326031,5.54234941 12.8323074,6.74436981 L17.7005,1.87516809 L12.5906598,1.87525774 C12.2524884,1.87525774 11.9725255,1.62603766 11.9244179,1.30124443 L11.917115,1.20171291 C11.917115,0.863541516 12.1663351,0.583578587 12.4911283,0.535471041 L12.5906598,0.528168085 L19.3274552,0.528168085 Z M7.88460211,6.15482686 C4.60328351,6.15482686 1.94258965,8.81552072 1.94258965,12.0968393 C1.94258965,15.3781579 4.60328351,18.0388518 7.88460211,18.0388518 C11.1659207,18.0388518 13.8266146,15.3781579 13.8266146,12.0968393 C13.8266146,8.81552072 11.1659207,6.15482686 7.88460211,6.15482686 Z M5.99100418,8.65036809 L7.9,13.7664769 L9.80899582,8.65036809 L11.55,8.65036809 L11.55,15.8434643 L10.3078801,15.8434643 L10.3078801,10.4728228 L8.52615063,15.2173137 L7.27384937,15.2173137 L5.49211994,10.4728228 L5.49211994,15.8434643 L4.25,15.8434643 L4.25,8.65036809 L5.99100418,8.65036809 Z",
  id: "gender-male-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "gender-male-Icon/Global/Male",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "gender-male-Swatches/Midnight",
  transform: "translate(1.000000, 2.649632)"
}, /*#__PURE__*/React.createElement("use", {
  id: "gender-male-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#gender-male-path-1"
})));

var SvgGenderMale = function SvgGenderMale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderMale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender-male.9e30139a.svg";
export { ForwardRef as ReactComponent };